export const CONTACT_BY_EMAIL = 'csv/CONTACT_BY_EMAIL';

export function contactByEmail(payload) {
  return { type: CONTACT_BY_EMAIL, payload };
}
